import React, { Component } from 'react';
import axios from 'axios';

import {
  NavLink,
  Redirect
} from 'react-router-dom';

class Register extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      mail: '',
      success: '',
      error: '',
      redirect: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value
    })
  }

  handleSubmit(event) {
    event.preventDefault();

    var self = this;

    if (this.state.password !== this.state.password2) {
      self.setState({
        'success': '',
        'error': 'Passwords do not match'
      });
      return;
    }

    axios.post('https://api.recordatifocus.com/user/password?_format=json', {
      mail: this.state.name
    })
    .then(function (response) {
      self.setState({
        'success': 'Registration successful',
        'error': ''
      });
      self.setState({redirect: true});
    })
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');
      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
  }

  render(){

    if (this.state.redirect) {
      return (
        <Redirect to="/user/login" />
      );
    }

    return (
      <div className="row top-buffer">
        <div className="col">
          <form className="col-md-4 offset-md-4 text-center" onSubmit={this.handleSubmit}>
          
          <div class="text-center fs-3 fw-bolder">Parola Yenileme</div>
          <div class="text-center mb-3">Parolanızı yenilemek için e-postanızı yazınız</div>
          
            <div className="form-group mb-3">
              <input name="name" value={this.state.name} onChange={this.handleChange} required type="text" className="form-control" placeholder="E-posta adresiniz" />
            </div>
            <button type="submit" className="btn btn-danger">Gönder</button>
            <div className="form-group messages mb-3">
              <p className="success">{this.state.success}</p>
              <p className="error" dangerouslySetInnerHTML={{__html: this.state.error}} />
            </div>
          
            <NavLink  className="link-dark text-decoration-none" to="/user/login">Giriş</NavLink>
          </form>
        </div>
      </div>
    );
  }
}

export default Register



// WEBPACK FOOTER //
// src/components/register.jsx